export default "bf01d6621b04876d.svg"